export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7949.fc2ff5a0.jpg";